/**
 * Staging — `ng build --configuration=staging` or `ng serve --configuration=staging`.
 */
export const environment = {
  production: false,
  envName: 'staging' as const,
  /** UAT: skip the Aadhaar checksum (Verhoeff) so any 12-digit number works for testing. */
  aadhaarRelaxChecksum: true,
  apiBaseUrl: 'https://apduatapi.katdev.com/api/v1',
};
